var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerEtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3627_5688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9629 41.7578C18.6273 41.7578 18.2944 41.6274 18.0367 41.3694L6.93605 30.1374C0.305172 23.4281 0.305172 12.5086 6.93605 5.79929C10.1495 2.54786 14.4206 0.757812 18.9629 0.757812C23.5052 0.757812 27.7763 2.54786 30.9897 5.79929C37.6206 12.5086 37.6206 23.4254 30.9897 30.1374L19.8891 41.3694C19.634 41.6274 19.2985 41.7578 18.9629 41.7578Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9629 41.7578C18.6273 41.7578 18.2944 41.6274 18.0367 41.3694L6.93605 30.1374C0.305172 23.4281 0.305172 12.5086 6.93605 5.79929C10.1495 2.54786 14.4206 0.757812 18.9629 0.757812C23.5052 0.757812 27.7763 2.54786 30.9897 5.79929C37.6206 12.5086 37.6206 23.4254 30.9897 30.1374L19.8891 41.3694C19.634 41.6274 19.2985 41.7578 18.9629 41.7578Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 9C11.9651 9 11.6667 9.30996 11.6667 9.69231C11.6667 10.0747 11.9651 10.3846 12.3333 10.3846V25.6154H11.6667C11.2985 25.6154 11 25.9253 11 26.3077C11 26.69 11.2985 27 11.6667 27H26.3333C26.7015 27 27 26.69 27 26.3077C27 25.9253 26.7015 25.6154 26.3333 25.6154H25.6667V10.3846C26.0349 10.3846 26.3333 10.0747 26.3333 9.69231C26.3333 9.30996 26.0349 9 25.6667 9H12.3333ZM16.3333 12.4615C15.9651 12.4615 15.6667 12.7715 15.6667 13.1538C15.6667 13.5362 15.9651 13.8462 16.3333 13.8462H17.6667C18.0349 13.8462 18.3333 13.5362 18.3333 13.1538C18.3333 12.7715 18.0349 12.4615 17.6667 12.4615H16.3333ZM15.6667 15.9231C15.6667 15.5407 15.9651 15.2308 16.3333 15.2308H17.6667C18.0349 15.2308 18.3333 15.5407 18.3333 15.9231C18.3333 16.3054 18.0349 16.6154 17.6667 16.6154H16.3333C15.9651 16.6154 15.6667 16.3054 15.6667 15.9231ZM16.3333 18C15.9651 18 15.6667 18.31 15.6667 18.6923C15.6667 19.0747 15.9651 19.3846 16.3333 19.3846H17.6667C18.0349 19.3846 18.3333 19.0747 18.3333 18.6923C18.3333 18.31 18.0349 18 17.6667 18H16.3333ZM19.6667 13.1538C19.6667 12.7715 19.9651 12.4615 20.3333 12.4615H21.6667C22.0349 12.4615 22.3333 12.7715 22.3333 13.1538C22.3333 13.5362 22.0349 13.8462 21.6667 13.8462H20.3333C19.9651 13.8462 19.6667 13.5362 19.6667 13.1538ZM20.3333 15.2308C19.9651 15.2308 19.6667 15.5407 19.6667 15.9231C19.6667 16.3054 19.9651 16.6154 20.3333 16.6154H21.6667C22.0349 16.6154 22.3333 16.3054 22.3333 15.9231C22.3333 15.5407 22.0349 15.2308 21.6667 15.2308H20.3333ZM19.6667 18.6923C19.6667 18.31 19.9651 18 20.3333 18H21.6667C22.0349 18 22.3333 18.31 22.3333 18.6923C22.3333 19.0747 22.0349 19.3846 21.6667 19.3846H20.3333C19.9651 19.3846 19.6667 19.0747 19.6667 18.6923ZM16.3333 24.9231V22.8462C16.3333 22.4638 16.6318 22.1538 17 22.1538H21C21.3682 22.1538 21.6667 22.4638 21.6667 22.8462V24.9231C21.6667 25.3054 21.3682 25.6154 21 25.6154H17C16.6318 25.6154 16.3333 25.3054 16.3333 24.9231Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3627_5688",
    x: 0.462891,
    y: 0.257812,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3627_5688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3627_5688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerEtc);
export default __webpack_public_path__ + "static/media/marker_etc.3c6c00a2e1dccada599b36587696088e.svg";
export { ForwardRef as ReactComponent };